import React from 'react';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';
import {chemicalBaseTypeNames} from 'helpers/constants';
import PropTypes from 'prop-types';
import CustomerModel from 'models/customer';
import PoolModel from 'models/pool';
import AnalysisModel from 'models/analysis';
import NoteSummary from 'components/notes/NoteSummary';

class NotePopover extends React.Component {
  static propTypes = {
    customer: PropTypes.instanceOf(CustomerModel).isRequired,
    pool: PropTypes.instanceOf(PoolModel),
    analysis: PropTypes.instanceOf(AnalysisModel),
    notes: PropTypes.array,
    editNote: PropTypes.func.isRequired,
    addNote: PropTypes.func.isRequired,
  };

  get title() {
    const {analysis, customer, pool} = this.props;

    if (analysis) {
      return <FormattedMessage id='notes.title.analysis' values={{name: moment(analysis.created).format('ll - LT')}} />;
    }

    if (pool) {
      return <FormattedMessage id='notes.title.system' values={{name: chemicalBaseTypeNames(pool.typeID, pool.chemicalBaseTypeID)}} />;
    }

    let contactName = customer.customerContacts !== null && customer.customerContacts.length > 0 ?
      customer.customerContacts
        .map(x => x.organization || [x.nameFirst, x.nameLast]
          .filter(y => !!y)
          .join(' '))
        .filter(x => !!x)
        .find(x => !!x) :
      undefined;

    if (!contactName) {
      return <FormattedMessage id='general.note'/>;
    }

    return <FormattedMessage id='notes.title.customer' values={{name: contactName}} />;
  }

  render() {
    const {customer, pool, analysis} = this.props;

    const filteredNotes = this.props.notes
      .filter(x => {
        if (analysis && analysis.id) {
          return x.analysisID === analysis.id;
        }

        if (pool && pool.id) {
          return !x.analysisID && x.systemID && x.systemID === pool.id;
        }

        return !x.analysisID && !x.systemID;
      });

    return <div className='notes__popover'>
      <div className='notes__popover__header'>
        <h3>{this.title}</h3>
      </div>

      <div className='notes__popover__notes'>
        {filteredNotes.map(x => <NoteSummary editNote={this.props.editNote} note={x} key={x.id} />)}
        {filteredNotes.length === 0 ? <p className='notes__popover__notes--none'><FormattedMessage id='notes.none' /></p> : null}
      </div>

      <div className='notes__popover__footer'>
        <a className='btn btn-default' href={`/#customer/timeline/${customer.id}`}>
          <FormattedMessage id='notes.see.all' />
        </a>
        <button className='btn btn-primary' onClick={this.props.addNote}>
          <i className='bl bl-add' />
          <FormattedMessage id='notes.add' />
        </button>
      </div>
    </div>;
  }
}

export default NotePopover;
